/* eslint-disable @typescript-eslint/no-explicit-any */
export const PortalsMapper = ({ portals }: { portals: any[] }) => {
  return (
    <>
      {portals.map((Portal, index) => (Portal ? <Portal key={index} /> : null))}
    </>
  );
};
